import { type PropsWithChildren, type ReactNode, Suspense } from 'react';

import {
  FlagResolverProvider,
  LoadingOverlay,
} from '@spotify/confidence-core-react';

import { OpenFeatureBoundary, useOpenFeatureFlagValue } from '../../vendor';

export type FlagEvaluationProviderProps = PropsWithChildren<{
  fallback?: ReactNode;
}>;

export const FlagEvaluationProvider = ({
  children,
  fallback = <LoadingOverlay loading />,
}: FlagEvaluationProviderProps) => (
  <OpenFeatureBoundary>
    <FlagResolverProvider resolver={useOpenFeatureFlagValue}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </FlagResolverProvider>
  </OpenFeatureBoundary>
);
